import { Injectable } from '@angular/core';

type StoragePayload<T> = {
  type: 'string' | 'number' | 'boolean' | 'object';
  value: T;
};

type StorageScope = 'local' | 'session';

@Injectable({ providedIn: 'root' })

export class StorageService {

  private getStorage(scope: StorageScope = 'local'): Storage {
    return scope === 'session' ? sessionStorage : localStorage;
  }

  /* ===================== SET ===================== */

  set<T>(key: string, value: T, scope: StorageScope = 'local'): void {
    try {
      const payload = { value };
      this.getStorage(scope).setItem(key, JSON.stringify(payload));
    } catch (error) {
      console.error(`Storage SET failed for key: ${key}`, error);
    }
  }

  /* ===================== GET ===================== */

  get<T>(key: string, scope: StorageScope = 'local'): T | null {
    try {
      const raw = this.getStorage(scope).getItem(key);
      if (!raw) return null;
      return JSON.parse(raw).value;
    } catch (error) {
      console.error(`Storage GET failed for key: ${key}`, error);
      return null;
    }
  }

  /* ===================== HELPERS ===================== */

  getString(key: string, scope: StorageScope = 'local'): string | null {
    return this.get<string>(key, scope);
  }

  /* ===================== REMOVE ===================== */

  remove(key: string, scope: StorageScope = 'local'): void {
    this.getStorage(scope).removeItem(key);
  }

  clear(scope: StorageScope = 'local'): void {
    this.getStorage(scope).clear();
  }
}

